'use client'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { FC, ReactNode } from 'react'

type ContentWrapperProps = {
  tag: 'section' | 'article' | 'div'
  children: ReactNode
  className?: string
  id?: string
}

const ContentWrapper: FC<ContentWrapperProps> = ({ tag, id, className, children }) => {
  const ContentWrapperTag = motion[tag]
  return (
    <ContentWrapperTag id={id} className={classNames('grid grid-cols-4 lg:grid-cols-12', className)}>
      {children}
    </ContentWrapperTag>
  )
}

export default ContentWrapper
